<div class="uk-inline uk-width-1-1">
  <span class="uk-form-icon uk-form-icon-flip" em-icon="search"></span>
  <input type="text" class="uk-input" placeholder="Search" (focusin)="drop().show()" (focusout)="drop().hide()" (input)="input($event)"
    (keydown.arrowdown)="nextItem($event)" (keydown.arrowup)="previousItem($event)" (keydown.enter)="select($event)" />
</div>
<div #dropdown class="uk-drop uk-dropdown">
  <ul class="uk-nav uk-dropdown-nav">
    @for (suggestion of suggestions(); track suggestion.id) {
      <li>
        <a class="uk-text-nowrap uk-drop-close" [class.op-filter-menu-item-highlight]="highlight() == $index" [uiSref]="suggestion.link"
          [uiParams]="suggestion.uiParams" (click)="highlight.set($index)">{{ suggestion.path }}</a>
      </li>
    }
    @empty {
      <li class="uk-text-center">
        <span>No results</span>
      </li>
    }
  </ul>
</div>
